import React from 'react';
import './blog-post.css';
import './blog-slides.css';
import food from './pictures/CPRfood.jpeg';
import attendees from './pictures/CPRattendees.jpeg';
import attendees2 from './pictures/CPRattendees2.jpeg';

const CleanPowerResearch = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header></header>
                <section>
                    <h2>Clean Power Research Office Tour</h2>
                    <p className="site-post-meta">April 7, 2026</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>
                    The Clean Power Research Office Tour was an interactive and engaging experience that began with breakfast and informal networking, where students had the opportunity to mingle with employees across the company, including the CEO, software engineers, and program managers. This was followed by a Q&A session with HR representatives, hiring managers, and recruiters, who provided valuable insights into the hiring process and what they look for in candidates.
                    <br></br>
                    <br></br>
                    After touring the office and getting a feel for the company's office culture, attendees participated in two informative panels—one focused on strategies for succeeding in technical interviews, and the other highlighting the meaningful environmental impact of Clean Power's work. Throughout the event, students learned about the company's services, culture, and the broader software engineering job and internship landscape. With around 20 students in attendance, the small, intimate setting allowed for genuine connections and meaningful conversations. The event, hosted by the Women in Computing club and open to all Allen School members, showcased Clean Power's welcoming and hospitable team while providing an enriching professional development experience.
                    <br></br>
                    <br></br>
                    </p>
                    <img src={attendees} alt="Attendees at Clean Power Research"/>
                    <img src={attendees2} alt="Attendees at Clean Power Research"/>
                    <img src={food} alt="Food at Clean Power Research"/>

                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default CleanPowerResearch;
